<template>
  <section class="lm-sections">
    <section class="lm-sections_title">{{ title }}</section>
    <ul class="lm-sections_list">
      <li class="lm-sections_item" v-for="(item, i) in list" :key="i"><span>{{ item.text }}</span></li>
    </ul>
  </section>
</template>

<style scoped lang="scss">
@import '@/assets/styles/variable.scss';

.lm-sections_title {
  margin-bottom: 12.16px;
  text-align: center;
  font-size: 29.6875px;
  font-weight: 700;
}
.lm-sections_list {
  display: flex;
  justify-content: center;
}
.lm-sections_item {
  border-right: 2px solid #000;
  padding-right: 13.194px;
  padding-left: 13.194px;
  font-size: 23.75px;
  &:last-child {
    border-right: none;
  }
  span {
    color: rgb(0, 108, 184);
    cursor: pointer;
    &:hover {
      border-bottom: 4px solid #006cb8;
    }
  }
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      require: true
    },
    list: {
      type: Array,
      require: true
    }
  }
}
</script>
